import { requestConfig } from "../config.js";

/**
 * Создать контрагента по номеру телефона
 *
 * @param {String} phoneNumber
 */
export async function apiCreateCustomerByPhoneNumber(phoneNumber) {
  const response = await requestConfig.post(
    "/api/v0/master/mobile_connect/create_customer_by_phone/",
    { phone: phoneNumber }
  );
  return response.data?.detail;
}

/**
 * Создать контрагента в ERP после авторизации на портале Госуслуги
 *
 * @param {String} customerKey
 * @param {String} localClientId
 * @param {String} providerId
 * @param {String} code
 * @param {String} state
 * @param {String} redirectUrl
 */
export async function apiCreateCustomerByPortal(
  customerKey,
  localClientId,
  providerId,
  code,
  state,
  redirectUrl
) {
  const response = await requestConfig.get("/api/v0/gosuslugi/create_customer/", {
    params: {
      key: customerKey,
      local_client_id: localClientId,
      provider_id: providerId,
      code: code,
      state: state,
      url: redirectUrl,
    },
  });

  // Если на портале госуслуг недостаточно данных для идентификации
  if (response.data.status_id === 500 || response.data.status_id === 700) {
    throw new Error(response.data.error_message);
  }
}

/**
 * Получить инициалы пользователя
 *
 * @param {String} ref
 */
export async function apiFetchCustomerInitials(ref) {
  const response = await requestConfig.get("/api/v0/master/mobile_connect/ref_fio_initials/", {
    params: {
      last_path_ref: ref,
    },
  });

  if (!response?.data) throw new Error("Unable to fetch initials of customer");

  return response.data?.detail;
}
